import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import SunMark from "./SunMark";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    ["Manifesto", "manifesto"],
    ["Features", "features"],
    ["A day", "day"],
  ];

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#F8F7F1]/80 border-b border-[#2B2B26]/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="brand-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2.5 text-[#2B2B26] group"
        >
          <SunMark className="text-[#D7263D] transition-transform duration-700 group-hover:rotate-90" />
          <span className="font-serif text-2xl leading-none text-[#1877F2]">My Life</span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map(([label, id]) => (
            <button
              key={id}
              data-testid={`nav-${id}`}
              onClick={() => scrollTo(id)}
              className="font-body text-sm text-[#2B2B26]/70 hover:text-[#2B2B26] transition-colors relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-[#2B2B26] after:transition-all hover:after:w-full"
            >
              {label}
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-waitlist-btn"
          onClick={() => scrollTo("waitlist")}
          className="rounded-full bg-[#2B2B26] text-[#F8F7F1] px-5 md:px-7 py-2.5 font-body text-sm font-medium transition-all duration-300 hover:bg-[#2B2B26]/90 hover:scale-[1.03] active:scale-95"
        >
          Join the waitlist
        </button>
      </div>
    </motion.header>
  );
};

export default Nav;
